import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.function.bind.js";
import "core-js/modules/es6.object.assign.js";

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import * as React from "react";

function Whatsapp(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M22 11.743c0 5.38-4.396 9.742-9.818 9.742-1.722 0-3.34-.44-4.746-1.212L2 22l1.772-5.227a9.64 9.64 0 01-1.408-5.03C2.364 6.362 6.759 2 12.182 2 17.606 2 22 6.362 22 11.743zm-9.818-8.191c-4.553 0-8.255 3.674-8.255 8.19A8.1 8.1 0 005.5 16.545l-1.03 3.043 3.171-1.008a8.254 8.254 0 004.542 1.354c4.551 0 8.254-3.674 8.254-8.19s-3.703-8.191-8.254-8.191zm4.958 10.435c-.06-.1-.221-.16-.461-.28-.24-.118-1.425-.697-1.645-.776-.22-.08-.382-.12-.542.12-.16.238-.621.776-.762.936-.14.16-.28.179-.521.06-.241-.12-1.016-.373-1.936-1.185-.715-.633-1.198-1.415-1.34-1.654-.139-.239-.013-.368.107-.487.109-.108.241-.28.36-.418.122-.14.162-.239.241-.398.08-.16.04-.3-.02-.42-.06-.118-.542-1.294-.741-1.772-.2-.477-.402-.398-.542-.398s-.301-.02-.46-.02c-.161 0-.423.06-.643.299-.22.238-.842.817-.842 1.992s.861 2.31.983 2.47c.12.158 1.663 2.648 4.11 3.604s2.447.637 2.888.597c.441-.04 1.424-.578 1.626-1.135.2-.558.2-1.036.14-1.135z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Whatsapp);
export default ForwardRef;